import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useAtom, useAtomValue } from 'jotai';
import { authUserAtom, authReadyAtom } from '@/stores/atoms/authAtoms';
import { sessionsAtom, recentSessionIdsAtom } from '@/stores/atoms/sessionAtoms';
import { mineGamesAtom } from '@/stores/atoms/mineAtoms';
import { loadSessions, saveSessions, loadMineGames, saveMineGames, loadRecentSessionIds, saveRecentSessionIds } from '@/renderer/storage/userLocal';
const DataPersistenceProvider = ({ children }) => {
    const user = useAtomValue(authUserAtom);
    const ready = useAtomValue(authReadyAtom);
    const [sessions, setSessions] = useAtom(sessionsAtom);
    const [mine, setMine] = useAtom(mineGamesAtom);
    const [recentIds, setRecentIds] = useAtom(recentSessionIdsAtom);
    // Load user data when auth becomes ready and user changes
    React.useEffect(() => {
        if (!ready)
            return;
        if (!user) {
            // Logged out: clear in-memory data per requirement (not visible)
            setSessions([]);
            setMine([]);
            setRecentIds([]);
            return;
        }
        const uid = user.uid;
        setSessions(loadSessions(uid));
        setMine(loadMineGames(uid));
        setRecentIds(loadRecentSessionIds(uid));
    }, [ready, user?.uid]);
    // Persist sessions on change
    React.useEffect(() => {
        if (!user)
            return;
        saveSessions(user.uid, sessions);
    }, [user?.uid, sessions]);
    // Persist mine on change
    React.useEffect(() => {
        if (!user)
            return;
        saveMineGames(user.uid, mine);
    }, [user?.uid, mine]);
    React.useEffect(() => {
        if (!user)
            return;
        saveRecentSessionIds(user.uid, recentIds);
    }, [user?.uid, recentIds]);
    return _jsx(_Fragment, { children: children });
};
export default DataPersistenceProvider;
